<template>
  <Container class="flex flex-col items-center">
    <Collapse
      v-for="(card, index) in data?.cards"
      :key="card.id"
      :open="data?.firstExpanded && index === 0"
      class="w-full max-w-[750px]"
    >
      <template #header>{{ card.title }}</template>
      <template #content>
        <article
          v-if="card?.copy"
          class="custom-list prose lg:prose-lg prose-a:text-sm prose-a:text-black prose-a:no-underline hover:prose-a:text-blue-dark lg:prose-a:text-black p-4 lg:p-6"
          v-html="card?.copy"
        ></article>
      </template>
    </Collapse>
  </Container>
</template>

<script setup lang="ts">
import Collapse from '../atoms/Collapse.vue'
import Container from '../atoms/Container.vue'
import type { ICardData } from '../../types'

export interface IExpandableSourcesBlock {
  id: string
  cards?: ICardData[]
  firstExpanded?: boolean
}

interface Props {
  data: IExpandableSourcesBlock
}

defineProps<Props>()
</script>
